import { AccessionConfigData } from './interfaces'

export interface SelectOption {
  label: string
  value: number
}

export const DEFAULT_ACCESSION_CONFIG: AccessionConfigData = {
  tamanhoCodigoValidador: 8,
  valorUnidadeReferencia: 322.93,
  urlSite:
    'https://www.basf.com/br/pt/who-we-are/BASF-Sociedade-de-Previdencia-Complementar',
  listaPatrocinadoras: [
    { label: 'BASF SA', value: 13 },
    { label: 'BASF PREVIDÊNCIA', value: 2 },
    { label: 'ADC BASF', value: 3 },
    { label: 'CREDIBASF', value: 4 },
    { label: 'BASF POLIURETANOS', value: 6 },
    { label: 'CHEMETALL', value: 9 },
    { label: 'BASF CATALISADORES', value: 12 },
    { label: 'CA SEMENTES', value: 11 },
    { label: 'SUVINIL SA', value: 15 },
    { label: 'BASF POLYMERS', value: 5 },
    { label: 'STYROLUTION', value: 7 },
    { label: 'BASF AG SPECIALTIES', value: 8 },
    { label: 'PL SEMENTES', value: 10 },
  ],
  listaParentesco: [
    { label: 'Avô / Avó', value: 12 },
    { label: 'Companheiro(a)', value: 2 },
    { label: 'Concubino(a)', value: 19 },
    { label: 'Cônjuge', value: 1 },
    { label: 'Enteado(a)', value: 8 },
    { label: 'Filho(a)', value: 3 },
    { label: 'Genro / Nora', value: 17 },
    { label: 'Irmão(ã)', value: 6 },
    { label: 'Menor', value: 10 },
    { label: 'Neto(a)', value: 14 },
    { label: 'Pai/mãe', value: 5 },
    { label: 'Sobrinho(a)', value: 15 },
    { label: 'Sogro(a)', value: 18 },
    { label: 'Tio(a)', value: 13 },
    { label: 'Outros', value: 0 },
    { label: 'Sem vinculo', value: 99 },
  ],
}

const normalizeOptions = (
  options: unknown,
  fallback: SelectOption[],
): SelectOption[] => {
  if (!Array.isArray(options) || options.length === 0) {
    return fallback
  }

  const normalized = options
    .map(option => {
      if (
        !option ||
        typeof option !== 'object' ||
        !('label' in option) ||
        !('value' in option)
      ) {
        return null
      }

      const label = String(option.label).trim()
      const value = Number(option.value)

      if (!label || Number.isNaN(value)) {
        return null
      }

      return { label, value }
    })
    .filter((option): option is SelectOption => option !== null)

  return normalized.length > 0 ? normalized : fallback
}

export const normalizeAccessionConfig = (
  data: Partial<AccessionConfigData> | undefined | null,
): AccessionConfigData => ({
  tamanhoCodigoValidador:
    typeof data?.tamanhoCodigoValidador === 'number' &&
    data.tamanhoCodigoValidador > 0
      ? data.tamanhoCodigoValidador
      : DEFAULT_ACCESSION_CONFIG.tamanhoCodigoValidador,
  valorUnidadeReferencia:
    typeof data?.valorUnidadeReferencia === 'number' &&
    data.valorUnidadeReferencia > 0
      ? data.valorUnidadeReferencia
      : DEFAULT_ACCESSION_CONFIG.valorUnidadeReferencia,
  urlSite:
    typeof data?.urlSite === 'string' && data.urlSite.trim()
      ? data.urlSite
      : DEFAULT_ACCESSION_CONFIG.urlSite,
  listaPatrocinadoras: normalizeOptions(
    data?.listaPatrocinadoras,
    DEFAULT_ACCESSION_CONFIG.listaPatrocinadoras,
  ),
  listaParentesco: normalizeOptions(
    data?.listaParentesco,
    DEFAULT_ACCESSION_CONFIG.listaParentesco,
  ),
})
